// extracted by mini-css-extract-plugin
export default {"container":"TablePage_container__XgAR6","fadeIn":"TablePage_fadeIn__txtRi"};